export default "__VITE_ASSET__DBlJ8ycK__"